import ImageUpload from "../../component/uploadImage";

const UploadImage = () => {
  return (
    <>
      <ImageUpload />
    </>
  );
};
export default UploadImage;
